module.exports = "https://portperrypedals.ca/_res/img/athletic.8a65f03.png";